module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cFGjjK/tc-custom/9781781314722.jpg?1738761060272",
      "alt": "This image is the cover for the book How UFOs Conquered the World"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How UFOs Conquered the World\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Cover[s] all the major themes of ufology, ranging from lights in the sky to crashed saucers, government cover-ups and alien abductions . . . fascinating.” —"), _c('i', [_vm._v("Popular Science Books")])]), _c('br'), _c('br'), _vm._v("Neither a credulous work of conspiracy theory nor a skeptical debunking of belief in “flying saucers,” "), _c('i', [_vm._v("How UFOs Conquered the World")]), _vm._v(" explores the origins of UFOs in the build-up to the First World War and how reports of them have changed in tandem with world events, science and culture. The book will also explore the overlaps between UFO belief and religion and superstition."), _c('br'), _c('br'), _c('b', [_vm._v("“An insightful, informative and thought-provoking book on UFOs and the UFO culture . . . In the following ten chapters, he writes about his pursuit of the ‘truth’ about UFOs. It is a fascinating journey.” —"), _c('i', [_vm._v("Skeptic")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Clarke\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aurum Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0